import Tour from 'bootstrap-tour';
import $ from 'jquery';
import HttpService from '../../common/http/HttpService';
import { TourEndpoint } from '../../common/endpoints/Endpoints';

function getSection() {
  return VCOM.section === 'cockpit' ? 'controlRoom' : VCOM.section;
}

function getTourByUser() {
  const data = { params: { section: getSection() } };
  return HttpService.get(TourEndpoint.GET_BY_USER, data);
}

async function getTour() {
  return {
    id: 1,
    header: 'tour.H_TOUR1',
    content: 'tour.TX_TOUR1',
  };
}

function setIsTourActive() {
  VCOM.isTourActive = true;
}

function setIsTourInactive() {
  VCOM.isTourActive = false;
}

function isTourActive() {
  return VCOM.isTourActive || false;
}

function startTour(tourConfig) {
  $.fn.popover.Constructor.Default.whiteList.button = ['data-role', 'disabled', 'tabindex'];
  const tour = new Tour(tourConfig);
  tour.init();
  tour.start();
  setIsTourActive();
}

async function saveTourForUser() {
  await HttpService.post(TourEndpoint.SAVE);
}

export default {
  getTour,
  getTourByUser,
  saveTourForUser,
  startTour,
  setIsTourActive,
  setIsTourInactive,
  isTourActive,
};
